/**
 * useSearchHistoryRouter
 * (主要用于房源列表 + 地图) 路由跳转
 * 
 * @Author: Focci
 * @Date: 2024-09-05 14:02:34
 * @Last Modified by: Focci
 * @Last Modified time: 2024-09-05 14:02:34
 */

import { listingBase } from '@lib/parse/urls'
import { generateUrl } from '@lib/utils'
import { parseURLSearchParams } from '@lib/redirect-url'
import { args } from '@lib/parse'
import { seasrchMap } from '@lib/route/house'
import { useLocale } from 'next-intl'
import { useCallback } from 'react'
import { useListing } from './mix/context'

export default function useSearchHistoryRouter() {
  const locale = useLocale()
  const { setSearchParam, setApiParam, setType, setQuery } = useListing()
  
  const initialParam = useCallback(({ type, param, query, isMapListing = true }) => {
    const slug = listingBase(param, isMapListing)
    const p = args.listing(slug, type, 40)
    let url = seasrchMap(type, slug, locale)
    
    //
    setType(type)
    setSearchParam(p.searchParam)
    setApiParam(p.apiParam)

    if(query) {
      setQuery(query)
      url = generateUrl(url, query)
    }

    return { ...p, slug, url }
  }, [locale, setApiParam, setQuery, setSearchParam, setType])

  /**
   * replaceState
   */
  const replaceUrl = useCallback((prop) => {
    const { url } = initialParam(prop || {})
    window.history.replaceState(null, '', url)
  }, [initialParam])

  /**
   * pushState
   */
  const pushUrl = useCallback((prop) => {
    const { url } = initialParam(prop || {})
    window.history.pushState(null, '', url)
  }, [initialParam])

  /**
   * url返回设置参数
   */
  const watchBackHandle = useCallback(() => {
    const { pathname: pn, search } = window.location
    const pns = pn.split('/')
    
    if(pns[1] === 'map') {
      const [slug, typeName] = pns.reverse()
      
      const p = args.listing(slug, typeName, 40)
      const q = parseURLSearchParams(search)

      setType(typeName)
      setSearchParam(p.searchParam)
      setApiParam(p.apiParam)
      setQuery(q)
    }
  }, [setApiParam, setQuery, setSearchParam, setType])

  /**
   * watch back
   */
  const watchBack = useCallback(() => {
    // 监听 history.pushState 返回事件
    window.addEventListener('popstate', watchBackHandle, true)
    return () => {
      window.removeEventListener('popstate', watchBackHandle, false)
    }
  }, [watchBackHandle])

  return {
    replaceUrl,
    pushUrl,
    watchBack
  }
}
